import { Component, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FormsModule } from '@angular/forms';
import {
  IonicModule,
  LoadingController,
  ModalController,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SolInputComponent } from '../../common/components/forms/sol-input/sol-input.component';
import { INPUT_TYPE } from '../../common/components/forms/sol-input/sol-input.enums';
import { ALERT_TYPE, AlertService } from '../../common/services/alert.service';

@Component({
  selector: 'sol-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['forgot-password.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, TranslateModule, SolInputComponent],
})
export class ForgotPasswordComponent {
  email: string | null | undefined;
  inputType = INPUT_TYPE;

  private alertService = inject(AlertService);
  private modalCtrl = inject(ModalController);
  private firestore = inject(Functions);
  private translateService = inject(TranslateService);
  private loadCtrl = inject(LoadingController);

  async onSubmitPasswordReset() {
    if (!this.email) {
      await this.alertService.showWindowAlert(
        this.translateService.instant('COMMON.emailNeeded'),
        this.translateService.instant('COMMON.emailNotValidMessage'),
        false
      );
      return;
    }

    const loader = await this.loadCtrl.create();
    await loader.present();

    const request = httpsCallable(this.firestore, 'forgotPassword');
    request({ email: this.email })
      .then(async () => {
        await this.alertService.showAlert(
          ALERT_TYPE.SUCCESS,
          this.translateService.instant('COMMON.forgotPasswordEmailSent'),
          4000,
          'bottom'
        );
      })
      .catch(async () => {
        await this.alertService.showAlert(
          ALERT_TYPE.ERROR,
          this.translateService.instant('COMMON.ALERTS.unknownError'),
          4000,
          'bottom'
        );
      })
      .finally(() => this.loadCtrl.dismiss());
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
